export { isEnvironment, isProduction } from '../environment/check';
